
export default [
  {
    identifier: 'dresses-trends',
    title: 'Top Trends: Dresses Trends',
    items: [
      {
        title: 'Long & Lean',
        modalDesc: 'The <strong>slim-lined silhouette</strong> (trending at the ankle-grazing length) has the modern woman in mind.',
        image: require(`@/assets/chapters/ch2/trends/Fluid.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Fluid_fr.jpg`)
      },
      {
        title: 'Animal Instinct',
        modalDesc: `From <strong>leopard to zebra</strong>, animal print dresses reigned supreme.`,
        image: require(`@/assets/chapters/ch2/trends/Animal-Prints.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Animal-Prints_fr.jpg`)
      },
      {
        title: 'New Romantics',
        modalDesc: 'Ruffled necklines, voluminous sleeves, and a hint of metallic: It’s all about dresses that bring a <strong>bit of drama</strong>.',
        image: require(`@/assets/chapters/ch2/trends/New-Romantics.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/New-Romantics_fr.jpg`)
      }
    ]
  },
  {
    identifier: 'handbags-trends',
    title: 'Top Trends: Handbags',
    items: [
      {
        title: 'Ultra Small',
        modalDesc: 'The growing trend is the <strong>shrinking size</strong>, and no one better exemplified it than Simon Porte Jacquemus who debuted Le Chiquiti, a bag the size of an index finger.',
        image: require(`@/assets/chapters/ch2/trends/The-Micro.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/The-Micro_fr.jpg`)
      },
      {
        title: 'Retro Lady Bags',
        modalDesc: `Structured frame bags with clip-top closures project a <strong>decidedly vintage feel</strong>.`,
        image: require(`@/assets/chapters/ch2/trends/Vintage-Frame.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Vintage-Frame_fr.jpg`)
      },
      {
        title: 'New Evening',
        modalDesc: 'Chainmail, faux fur, and embellishment provided <strong>glamorous alternatives</strong> to the standard evening bag.',
        image: require(`@/assets/chapters/ch2/trends/New-Evening.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/New-Evening_fr.jpg`)
      }
    ]
  },
  {
    identifier: 'shoes-trends',
    title: 'Top Trends: Shoes',
    items: [
      {
        title: 'Off-Duty Boots',
        modalDesc: 'Fashion meets function with all-weather, <strong>utilitarian styles</strong> such as combat and moto boots with practical soles.',
        image: require(`@/assets/chapters/ch2/trends/Off-Duty-Boots.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Off-Duty-Boots_fr.jpg`)
      },
      {
        title: 'New Heights',
        modalDesc: '<strong>Boots to the knee</strong> and over were rendered in a variety of exotic prints as well as more classic leather.',
        image: require(`@/assets/chapters/ch2/trends/Straight-Knee-Boots.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Straight-Knee-Boots_fr.jpg`)
      },
      {
        title: 'Ladylike Glamour',
        modalDesc: 'Pumps, Mary Janes, and T-strap silhouettes returned to the runway in a <strong>play for new polish</strong>.',
        image: require(`@/assets/chapters/ch2/trends/Ladylike-Glamour.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Ladylike-Glamour_fr.jpg`)
      }
    ]
  },
  {
    identifier: 'outerwear-trends',
    title: 'Top Trends: Outerwear',
    items: [
      {
        title: 'Faux',
        modalDesc: 'Designers and customers continued to opt for <strong>fur alternatives</strong>, found this season in ultra-luxe, cruelty-free faux fur.',
        image: require(`@/assets/chapters/ch2/trends/Faux-Fur.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Faux-Fur_fr.jpg`)
      },
      {
        title: 'Cape Town',
        modalDesc: `It's the key silhouette update for fall. The cape's timely come-back for fall will provide and <strong>easy, yet chic outerwear staple</strong>.`,
        image: require(`@/assets/chapters/ch2/trends/Cape.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Cape_fr.jpg`)
      },
      {
        title: 'New Hertiage',
        modalDesc: '<strong>Traditional fabrics</strong> from check to plaid to tweed—have been reworked and rethought.',
        image: require(`@/assets/chapters/ch2/trends/Modern-Heritage.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Modern-Heritage_fr.jpg`)
      }
    ]
  },
  {
    identifier: 'accessories-trends',
    title: 'Top Trends: Accessories',
    items: [
      {
        title: 'In a Cinch',
        modalDesc: '<strong>Wide, waist-cinching belts</strong> are used to style everything from blazers to dresses.',
        image: require(`@/assets/chapters/ch2/trends/Wide-Belt.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Wide-Belt_fr.jpg`)
      },
      {
        title: 'Clip Bait',
        modalDesc: 'A nostalgic nod to the 90’s, clips and barrettes were a favorite this season, the prettiest of which came with pearls.',
        image: require(`@/assets/chapters/ch2/trends/Hair-Clip.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Hair-Clip_fr.jpg`)
      },
      {
        title: 'Headbands',
        modalDesc: 'In the long run revival, headbands continue to sweep the street and runways alike - padded for height or adorned with feathers.',
        image: require(`@/assets/chapters/ch2/trends/Headband.jpg`),
        fullResImage: require(`@/assets/chapters/ch2/trends/Headband_fr.jpg`)
      }
    ]
  }
]
